
document.addEventListener("DOMContentLoaded", function() {
  const modal = document.getElementById("galleryModal");
  const slides = modal.querySelectorAll(".gallery-modal__slide");
  const slider = modal.querySelector(".gallery-modal__slider");
  const closeBtn = modal.querySelector(".gallery-modal__close");
  const nextBtn = modal.querySelector(".gallery-modal__next");
  const prevBtn = modal.querySelector(".gallery-modal__prev");
  let currentIndex = 0;

  // Open on click
  document.querySelectorAll(".gallery-overlay").forEach((btn, index) => {
    btn.addEventListener("click", () => {
      modal.classList.remove("hidden");
      currentIndex = index;
      updateSlide();
    });
  });

  // Close
  closeBtn.addEventListener("click", () => modal.classList.add("hidden"));
  modal.querySelector(".gallery-modal__overlay").addEventListener("click", () => modal.classList.add("hidden"));

  // Next/Prev
  nextBtn.addEventListener("click", () => {
    currentIndex = (currentIndex + 1) % slides.length;
    updateSlide();
  });
  prevBtn.addEventListener("click", () => {
    currentIndex = (currentIndex - 1 + slides.length) % slides.length;
    updateSlide();
  });

  function updateSlide() {
    slider.style.transform = `translateX(-${currentIndex * 100}%)`;
  }
});

